__webpack_require__.p = "https://cportal.b-alert.com/sleep-profiler/";